import { noop } from '@crocodille/common';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ShippingType } from '../../../routing';

import Modal from '../../elements/modal/modal';
import ShippingSelection from '../shipping-selection/shipping-selection';
import styles from './shipping-modal.module.scss';
import { useMedia } from '@hooks/use-media';

export interface ShippingModalProps {
  readonly open: boolean;
  onClose?(shippingPicked?: boolean): void;
}

const ShippingModal: React.FC<React.PropsWithChildren<ShippingModalProps>> = ({
  open,
  onClose = noop,
}) => {
  const [shipping, setShipping] = useState<ShippingType>('courier');
  const { t } = useTranslation();
  const isMobile = useMedia('shipping-modal-btn', true);

  const navigateToProductList = useCallback(() => {
    onClose(true);
  }, [onClose]);

  const handleCLoseModal = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeOnOutsideClick={true}
      title={t('shipping.shipping_choice')}
      showCloseButton={!isMobile}
      hideTitle={true}
      height="fill"
      transparent
      dialogClassName={styles.modalPadding}
    >
      <>
        <div className={styles.container}>
          <ShippingSelection
            selectedShipping={shipping}
            onSelectedShippingChange={setShipping}
            navigateToProductList={navigateToProductList}
            isMainLayout={false}
          />
        </div>
        <div onClick={handleCLoseModal} className={styles.backlog}></div>
      </>
    </Modal>
  );
};

export default ShippingModal;
